import {DEFAULT_VISIBLE_COLUMN_KEYS, LG_COLUMNS, type ColumnKey} from '../constants/listColumns';
import {usePersistedColumnVisibility, type ColumnVisibility} from './usePersistedColumnVisibility';

export type UseColumnVisibility = ColumnVisibility<ColumnKey>;

const STORAGE_KEY = 'ticketList.visibleColumns.v1';

/** Column visibility for the ticket list table. */
export function useColumnVisibility(): UseColumnVisibility {
	return usePersistedColumnVisibility<ColumnKey>({
		storageKey: STORAGE_KEY,
		columns: LG_COLUMNS,
		defaultVisibleKeys: DEFAULT_VISIBLE_COLUMN_KEYS,
	});
}
